import React from "react";

import ChecklistCard from "../../components/checklist-card/ChecklistCard";
import type {ChecklistCardData} from "../../types";
import styles from './ChecklistSection.module.scss';
import LeftImage from './images/left.png';
import RightImage from './images/right.png';
import {EMOJIS} from "../../../../../config/constants";
import H1 from "../../components/typography/H1";
import {useWindowWidth} from "../../../../../services/useWindowWidth";
import {getPartnerLanguage} from '../../locales/language';


const getCards = (): ChecklistCardData[] => [
    {
        title: <><span className={styles.titleAccent}>Win</span>{getPartnerLanguage() === 'ru' && <br className={styles.titleBreak}/>} {'new repeat clients'}</>,
        image: LeftImage,
        list: [
            {
                emoji: EMOJIS.INPUT_NUMBERS,
                text: <>Importers <strong>calculate total landed cost</strong> on the platform, including all fees and services</>,
            },
            {
                emoji: EMOJIS.SPARKLE_STAR,
                text: <>The platform <strong>recommends you</strong> as a carrier when clients choose providers. You receive a request with cargo details, a route and a budget</>,
            },
            {
                emoji: EMOJIS.INCOMING_MESSAGE,
                text: <>You <strong>start work on the request</strong> without lengthy initial discussions with the client</>,
            },
        ]
    },
    {
        title: <><span className={styles.titleAccent}>Serve</span>{getPartnerLanguage() === 'ru' && <br className={styles.titleBreak}/>} {'existing clients better'}</>,
        image: RightImage,
        list: [
            {
                emoji: EMOJIS.KEY,
                text: <><strong>Use the platform</strong> as an internal tool to instantly prepare all-inclusive quotes</>,
            },
            {
                emoji: EMOJIS.SPEECH_BALLOON,
                text: <><strong>Respond to inquiries</strong> from existing clients with a full cost calculation that fits their overall budget, alongside your shipping rate</>,
            },
            {
                emoji: EMOJIS.HIGH_VOLTAGE,
                text: <><strong>Reduce your team's workload</strong> by collecting key details upfront and collaborating with partners on a shared deal</>,
            },
        ]
    }
]

function ChecklistSection() {
    const cards = getCards();
    const width = useWindowWidth();
    const isMobileScenarioLayout = width <= 767;

    return (
        <div className={styles.section} id="examples">
            <div className={styles.sectionContainer}>
                <div className={styles.titleContainer}>
                    <H1>Vedmarket use cases</H1>
                </div>
                <div className={isMobileScenarioLayout ? styles.mobileCards : styles.cards}>
                    {cards.map((idea, index) => (
                        <ChecklistCard
                            key={index}
                            card={idea}
                            isReversed={index % 2 === 1}
                            isScenario
                            showScenarioButtons={index === cards.length - 1}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
}

export default ChecklistSection
